<template>
	<div class="number input__type">
		<label :for="id_" v-if="!reversed">
			<span>{{ title }}</span>
		</label>
		<div class="control number">
			<button
				class="increment-button icon-plus-1"
				type="button"
				:disabled="incrementDisabled"
				@click="increment"
			></button>
			<button
				class="decrement-button icon-minus-1"
				type="button"
				:disabled="decrementDisabled"
				@click="decrement"
			></button>
			<input
				:id="id_"
				:name="name_"
				:class="inputClassObject"
				type="number"
				:disabled="inputDisabled"
				:min="min"
				:max="max"
				:step="step"
				v-bind="attrs"
				v-model="value_"
				@keydown.up.prevent="increment"
				@keydown.down.prevent="decrement"
				@keydown.esc="value_ = value"
				@keydown.enter="saveValue"
				@blur="saveValue"
			/>
		</div>
		<label :for="id_" v-if="reversed">
			<span>{{ title }}</span>
		</label>
		<MErrors v-if="errors_" :errors="errors_" />
	</div>
</template>

<script>
import { createNameFromVModelExpr } from '../../index';
import MErrors from './MErrors';

export default {
	name: 'MInputNumber',
	components: { MErrors },
	props: {
		id: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			required: false
		},
		title: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
		attrs: {
			type: Object,
			default() {
				return {}
			}
		},
		reversed: {
			type: Boolean,
			default: false
		},
		errors: {
			type: Object,
			default() {
				return {}
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		max: {
			type: Number,
			default: Infinity
		},
		min: {
			type: Number,
			default: -Infinity
		},
		value: {
			required: true
		},
		step: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			id_: this.id,
			name_: this.name,
			value_: this.value,
			decrementDisabled: false,
			incrementDisabled: false,
			inputDisabled: false
		}
	},

	methods: {
		increment() {
			if (this.disabled || this.incrementDisabled) {
				return;
			}

			let newVal = parseInt(this.value_) + this.step;
			this.decrementDisabled = false;

			this._updateValue(newVal);
		},
		decrement() {
			if (this.disabled || this.decrementDisabled) {
				return;
			}

			let newVal = parseInt(this.value_) - this.step;
			this.incrementDisabled = false;

			this._updateValue(newVal);
		},
		_updateValue(newVal) {
			const oldVal = this.value_;
			if (oldVal === newVal || typeof this.value !== 'number') {
				return;
			}
			if (newVal <= this.min) {
				newVal = this.min;
				this.decrementDisabled = true;
			}
			if (newVal >= this.max) {
				newVal = this.max;
				this.incrementDisabled = true;
			}
			this.value_ = newVal;
			this.saveValue();
		},
		saveValue() {
			let newVal = this.value_;
			if (this.value_ > this.max) {
				newVal = this.max;
			} else if (this.value_ < this.min) {
				newVal = this.min;
			}
			this.value_ = newVal;
			this.$emit('input', newVal);
		}
	},

	created() {
		const id = createNameFromVModelExpr(this);
		const name = this.$vnode.data.model.expression;

		if (id && !this.id_) this.id_ = id;

		if (name && !this.name_) this.name_ = name;
	},
	computed: {
		errors_() {
			return this.errors.getOwnPropertyDescriptor(this.name_)
				? this.errors[this.name_]
				: false;
		},
		inputClassObject() {
			return this.errors_ ? ['warning'] : [];
		}
	},

	mounted() {
		if (this.value === this.min) {
			this.decrementDisabled = true;
		}
	},
	watch: {
		value_(new_) {
			this.$emit('input', parseInt(new_));
		},
		value(new_) {
			this.value_ = parseInt(new_);
		}
	}
}
</script>

<style scoped></style>
